<cheelee-responsive-layout displayNavBar onePage>
  <main class="cheelee-feed" [style.padding-top]="isMobile() ? 0 : headerHeight() + 'px'">
    @if (isFeedLoading()) {
      <cheelee-loader class="cheelee-feed__loader" />
    } @else {
      <cheelee-media-list [feed]="feed()"/>
    }
  </main>
</cheelee-responsive-layout>

